/**
 * @fileoverview GET handler for the "/engagement/braze_report_dashboard/:type" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementBrazeReportDashboardType } from "./constants";
import type { EngagementBrazeReportDashboardTypeResult } from "./types";

export const getEngagementBrazeReportDashboardType = reactQueryFetcherAdapter(
  engagementBrazeReportDashboardType,
  (signal: AbortSignal, type: string): Promise<EngagementBrazeReportDashboardTypeResult> => {
    return fetch(`/engagement/braze_report_dashboard/${type}`, "GET", {}, { signal });
  }
);
